import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

import Home from './components/pages/Home/Home';
import Internet from './components/pages/Internet/Internet';
import P2P from './components/pages/Internet/P2P';
import TDLTE from './components/pages/Internet/TDLTE';

// Domain Pages
import Domain from './components/pages/Domain/Domain';
import DomainNational from './components/pages/Domain/DomainNational';
import DomainInternational from './components/pages/Domain/DomainInternational';
import DomainTransfer from './components/pages/Domain/DomainTransfer';

// Hosting Pages
import Hosting from './components/pages/Hosting/Hosting';
import HostingCpanelIran from './components/pages/Hosting/HostingCpanelIran';
import HostingCpanelForeign from './components/pages/Hosting/HostingCpanelForeign';
import HostingLinux from './components/pages/Hosting/HostingLinux';
import HostingWindows from './components/pages/Hosting/HostingWindows';
import HostingDirectAdmin from './components/pages/Hosting/HostingDirectAdmin';
import HostingWordPress from './components/pages/Hosting/HostingWordPress';

// VPS Pages
import VPS from './components/pages/VPS/VPS';
import VPSLinux from './components/pages/VPS/VPSLinux';
import VPSWindows from './components/pages/VPS/VPSWindows';
import VPSManaged from './components/pages/VPS/VPSManaged';
import VPSNetherlands from './components/pages/VPS/VPSNetherlands';
import VPSGermany from './components/pages/VPS/VPSGermany';
import VPSMikrotik from './components/pages/VPS/VPSMikrotik';
import VPSTurkey from './components/pages/VPS/VPSTurkey';
import VPSUSA from './components/pages/VPS/VPSUSA';
import VPSUK from './components/pages/VPS/VPSUK';
import VPSFrance from './components/pages/VPS/VPSFrance';
import VPSCanada from './components/pages/VPS/VPSCanada';

// Dedicated Pages
import Dedicated from './components/pages/Dedicated/Dedicated';
import DedicatedManaged from './components/pages/Dedicated/DedicatedManaged';
import DedicatedIran from './components/pages/Dedicated/DedicatedIran';
import DedicatedTurkey from './components/pages/Dedicated/DedicatedTurkey';
import DedicatedNetherlands from './components/pages/Dedicated/DedicatedNetherlands';
import Colocation from './components/pages/Dedicated/Colocation';

// Licenses Pages
import Licenses from './components/pages/Licenses/Licenses';
import LicenseCpanel from './components/pages/Licenses/LicenseCpanel';
import LicenseDirectAdmin from './components/pages/Licenses/LicenseDirectadmin';
import LicenseImmunify from './components/pages/Licenses/LicenseImmunify';
import LicenseLiteSpeed from './components/pages/Licenses/LicenseLitespeed';
import LicenseCloudLinux from './components/pages/Licenses/LicenseCloudlinux';
import LicenseJetBackup from './components/pages/Licenses/LicenseJetbackup';
import LicenseSoftaculous from './components/pages/Licenses/LicenseSoftaculous';
import LicenseVirtualizor from './components/pages/Licenses/LicenseVirtualizor';
import LicensePlesk from './components/pages/Licenses/LicensePlesk';
import LicenseKernelCare from './components/pages/Licenses/LicenseKernelcare';
import LicenseSolusVM from './components/pages/Licenses/LicenseSolusvm';
import LicenseWHMReseller from './components/pages/Licenses/LicenseWhmreseller';
import LicenseDAReseller from './components/pages/Licenses/LicenseDirectadminreseller';
import LicenseCPNginx from './components/pages/Licenses/LicenseCpnginx';
import LicenseSitePad from './components/pages/Licenses/LicenseSitepad';
import LicenseOSM from './components/pages/Licenses/LicenseOsm';
import LicenseWHMCSSonic from './components/pages/Licenses/LicenseWhmcssonic';
import LicenseMailScaner from './components/pages/Licenses/LicenseMailscaner';

// Server Config Pages
import ServerConfig from './components/pages/ServerConfig/ServerConfig';
import ConfigCpanel from './components/pages/ServerConfig/ConfigCpanel';
import ConfigDirectAdmin from './components/pages/ServerConfig/ConfigDirectAdmin';
import ConfigVirtualizor from './components/pages/ServerConfig/ConfigVirtualizor';
import ConfigESXi from './components/pages/ServerConfig/ConfigESXi';
import ConfigDocker from './components/pages/ServerConfig/ConfigDocker';
import ConfigPlesk from './components/pages/ServerConfig/ConfigPlesk';

// WHMCS Pages
import WHMCS from './components/pages/WHMCS/WHMCS';
import WHMCSLicense from './components/pages/WHMCS/WHMCSLicense';
import WHMCSInstall from './components/pages/WHMCS/WHMCSInstall';
import WHMCSModules from './components/pages/WHMCS/WHMCSModules';
import WHMCSPaymentGateway from './components/pages/WHMCS/WHMCSPaymentGateway';
import WHMCSTemplate from './components/pages/WHMCS/WHMCSTemplate';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/internet" element={<Internet />} />
          <Route path="/internet/p2p" element={<P2P />} />
          <Route path="/internet/tdlte" element={<TDLTE />} />
          
          {/* Domain Routes */}
          <Route path="/domain" element={<Domain />} />
          <Route path="/domain/national" element={<DomainNational />} />
          <Route path="/domain/international" element={<DomainInternational />} />
          <Route path="/domain/transfer" element={<DomainTransfer />} />
          
          {/* Hosting Routes */}
          <Route path="/hosting" element={<Hosting />} />
          <Route path="/hosting/cpanel-iran" element={<HostingCpanelIran />} />
          <Route path="/hosting/cpanel-foreign" element={<HostingCpanelForeign />} />
          <Route path="/hosting/linux" element={<HostingLinux />} />
          <Route path="/hosting/windows" element={<HostingWindows />} />
          <Route path="/hosting/directadmin" element={<HostingDirectAdmin />} />
          <Route path="/hosting/wordpress" element={<HostingWordPress />} />
          
          {/* VPS Routes */}
          <Route path="/vps" element={<VPS />} />
          <Route path="/vps/linux" element={<VPSLinux />} />
          <Route path="/vps/windows" element={<VPSWindows />} />
          <Route path="/vps/managed" element={<VPSManaged />} />
          <Route path="/vps/netherlands" element={<VPSNetherlands />} />
          <Route path="/vps/germany" element={<VPSGermany />} />
          <Route path="/vps/mikrotik" element={<VPSMikrotik />} />
          <Route path="/vps/turkey" element={<VPSTurkey />} />
          <Route path="/vps/usa" element={<VPSUSA />} />
          <Route path="/vps/uk" element={<VPSUK />} />
          <Route path="/vps/france" element={<VPSFrance />} />
          <Route path="/vps/canada" element={<VPSCanada />} />
          
          {/* Dedicated Routes */}
          <Route path="/dedicated" element={<Dedicated />} />
          <Route path="/dedicated/managed" element={<DedicatedManaged />} />
          <Route path="/dedicated/iran" element={<DedicatedIran />} />
          <Route path="/dedicated/turkey" element={<DedicatedTurkey />} />
          <Route path="/dedicated/netherlands" element={<DedicatedNetherlands />} />
          <Route path="/dedicated/colocation" element={<Colocation />} />
          
          {/* Licenses Routes */}
          <Route path="/licenses" element={<Licenses />} />
          <Route path="/licenses/cpanel" element={<LicenseCpanel />} />
          <Route path="/licenses/directadmin" element={<LicenseDirectAdmin />} />
          <Route path="/licenses/immunify" element={<LicenseImmunify />} />
          <Route path="/licenses/litespeed" element={<LicenseLiteSpeed />} />
          <Route path="/licenses/cloudlinux" element={<LicenseCloudLinux />} />
          <Route path="/licenses/jetbackup" element={<LicenseJetBackup />} />
          <Route path="/licenses/softaculous" element={<LicenseSoftaculous />} />
          <Route path="/licenses/virtualizor" element={<LicenseVirtualizor />} />
          <Route path="/licenses/plesk" element={<LicensePlesk />} />
          <Route path="/licenses/kernelcare" element={<LicenseKernelCare />} />
          <Route path="/licenses/solusvm" element={<LicenseSolusVM />} />
          <Route path="/licenses/whmreseller" element={<LicenseWHMReseller />} />
          <Route path="/licenses/directadminreseller" element={<LicenseDAReseller />} />
          <Route path="/licenses/cpnginx" element={<LicenseCPNginx />} />
          <Route path="/licenses/sitepad" element={<LicenseSitePad />} />
          <Route path="/licenses/osm" element={<LicenseOSM />} />
          <Route path="/licenses/whmcssonic" element={<LicenseWHMCSSonic />} />
          <Route path="/licenses/mailscaner" element={<LicenseMailScaner />} />
          
          {/* Server Config Routes */}
          <Route path="/server-config" element={<ServerConfig />} />
          <Route path="/server-config/cpanel" element={<ConfigCpanel />} />
          <Route path="/server-config/directadmin" element={<ConfigDirectAdmin />} />
          <Route path="/server-config/virtualizor" element={<ConfigVirtualizor />} />
          <Route path="/server-config/esxi" element={<ConfigESXi />} />
          <Route path="/server-config/docker" element={<ConfigDocker />} />
          <Route path="/server-config/plesk" element={<ConfigPlesk />} />
          
          {/* WHMCS Routes */}
          <Route path="/whmcs" element={<WHMCS />} />
          <Route path="/whmcs/license" element={<WHMCSLicense />} />
          <Route path="/whmcs/install" element={<WHMCSInstall />} />
          <Route path="/whmcs/modules" element={<WHMCSModules />} />
          <Route path="/whmcs/payment-gateway" element={<WHMCSPaymentGateway />} />
          <Route path="/whmcs/template" element={<WHMCSTemplate />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
